module.exports = "/img/favicon-unread-messages.svg?a57c6242a5eeb236a19e969a81deb7c0";